// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Z7-z"};